var initMiewEstagios = function () {
    function animateElements(nextSlide) {
        var picture = $('.estagios_divs:eq(' + nextSlide + ')').find('picture')[0];
        var figcaption = $('.estagios_divs:eq(' + nextSlide + ')').find('figcaption')[0];
        
        TweenLite.to([picture, figcaption], 1.5, {
            y: 0,
            autoAlpha: 1,
            delay:0.5,
            ease: Power2.easeout,
        });
    }

    $('.estagios-slick').on('init', function () {
        animateElements(0);
    });
    $('.estagios-slick').slick({
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        cursors: true,
        infinite: false,
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 5000,
    });
    $('.estagios-slick').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var picture = $('.estagios_divs:eq(' + currentSlide + ')').find('picture')[0];
        var figcaption = $('.estagios_divs:eq(' + currentSlide + ')').find('figcaption')[0];

        TweenLite.to(picture, 1.5, {
            autoAlpha: 0,
            y: 80,
            delay: 0.5,
            ease: Power2.easeout,
        });
        TweenLite.to(figcaption, 1.5, {
            autoAlpha: 0,
            y: -80,
            delay: 0.5,
            ease: Power2.easeout,
        });

        animateElements(nextSlide);
    });
}
